"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;
exports.parseFile = exports.matchFile = exports.countries = exports.parsers = void 0;

var papaparse_1 = require("papaparse");

require("mdn-polyfills/String.prototype.padStart");

var uniq_1 = __importDefault(require("lodash/uniq"));

var last_1 = __importDefault(require("lodash/last"));

var outbank_1 = require("./de/outbank/outbank");

var _1822direkt_1 = require("./de/1822direkt/1822direkt");

var n26_1 = require("./de/n26/n26");

var revolut_1 = require("./international/revolut/revolut");

var ing_diba_1 = require("./de/ing-diba/ing-diba");

var comdirect_1 = require("./de/comdirect/comdirect");

var kontist_1 = require("./de/kontist/kontist");

var volksbank_eg_1 = require("./de/volksbank-eg/volksbank-eg");

var ing_austria_1 = require("./at/ing/ing-austria");

var bbva_bancomer_1 = require("./mx/bbva-bancomer/bbva-bancomer");

var piraeus_1 = require("./gr/piraeus/piraeus");

var marcus_1 = require("./uk/marcus/marcus");

var aqua_1 = require("./uk/aqua/aqua");

var bank2ynab_1 = require("./bank2ynab/bank2ynab");

var sparbanken_tanum_1 = require("./se/sparbanken-tanum/2018/sparbanken-tanum");

var sparbanken_tanum_2 = require("./se/sparbanken-tanum/2019/sparbanken-tanum");

var mt940_1 = require("./international/mt940/mt940");

var mbank_1 = require("./pl/mbank/mbank");

var bank_pocztowy_1 = require("./pl/bank-pocztowy/bank-pocztowy");

var seb_1 = require("./se/seb-privat/seb");

exports.parsers = __spreadArrays([// AT
ing_austria_1.ingAustria, // DE
outbank_1.outbank, n26_1.n26, ing_diba_1.ingDiBa, comdirect_1.comdirect, kontist_1.kontist, volksbank_eg_1.volksbankEG, _1822direkt_1._1822direkt, // GR
piraeus_1.piraeus, // MX
bbva_bancomer_1.bancomer, // SE
sparbanken_tanum_1.sparbankenTanum, sparbanken_tanum_2.sparbankenTanum, seb_1.seb, // UK
marcus_1.marcus, aqua_1.aqua, // PL
mbank_1.mbank, bank_pocztowy_1.bankPocztowy, // International
revolut_1.revolut, mt940_1.mt940], bank2ynab_1.bank2ynab);
exports.countries = uniq_1["default"](exports.parsers.filter(function (p) {
  return p.country.length === 2;
}).map(function (p) {
  return p.country;
}));

exports.matchFile = function (file) {
  return __awaiter(void 0, void 0, void 0, function () {
    var filenameMatches, parsers_1, results;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (file.name.match(/^(.+)-ynap\.csv$/)) {
            throw new Error('This file has already been converted by YNAP.');
          }

          filenameMatches = exports.parsers.filter(function (p) {
            return file.name.match(p.filenamePattern);
          });
          if (!(filenameMatches.length > 0)) return [3
          /*break*/
          , 2];
          return [4
          /*yield*/
          , Promise.all(filenameMatches.map(function (p) {
            return __awaiter(void 0, void 0, void 0, function () {
              var _a;

              return __generator(this, function (_b) {
                switch (_b.label) {
                  case 0:
                    _a = {
                      parser: p
                    };
                    return [4
                    /*yield*/
                    , p.match(file)];

                  case 1:
                    return [2
                    /*return*/
                    , (_a.matched = _b.sent(), _a)];
                }
              });
            });
          }))];

        case 1:
          parsers_1 = _a.sent().filter(function (r) {
            return r.matched;
          }).map(function (p) {
            return p.parser;
          });

          if (parsers_1.length > 0) {
            return [2
            /*return*/
            , parsers_1];
          }

          _a.label = 2;

        case 2:
          return [4
          /*yield*/
          , Promise.all(exports.parsers.filter(function (p) {
            return p.fileExtension.toLowerCase() === last_1["default"](file.name.split('.')).toLowerCase();
          }).map(function (p) {
            return __awaiter(void 0, void 0, void 0, function () {
              var _a;

              return __generator(this, function (_b) {
                switch (_b.label) {
                  case 0:
                    _a = {
                      parser: p
                    };
                    return [4
                    /*yield*/
                    , p.match(file)];

                  case 1:
                    return [2
                    /*return*/
                    , (_a.matched = _b.sent(), _a)];
                }
              });
            });
          }))];

        case 3:
          results = _a.sent().filter(function (r) {
            return r.matched;
          }).map(function (p) {
            return p.parser;
          });
          return [2
          /*return*/
          , results];
      }
    });
  });
};

exports.parseFile = function (file, parserOverride) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parser, matches, ynabData;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          parser = null;
          if (!parserOverride) return [3
          /*break*/
          , 1];
          parser = parserOverride;
          return [3
          /*break*/
          , 3];

        case 1:
          return [4
          /*yield*/
          , exports.matchFile(file)];

        case 2:
          matches = _a.sent();
          console.log('The file', file.name, 'was matched by', matches.map(function (m) {
            return m.name;
          }).join(', '));
          parser = matches.length > 0 ? matches[0] : null;
          _a.label = 3;

        case 3:
          if (!parser) {
            throw new Error("No parser is available for this file.");
          }

          return [4
          /*yield*/
          , parser.parse(file)];

        case 4:
          ynabData = _a.sent();
          return [2
          /*return*/
          , ynabData.map(function (f) {
            return __assign(__assign({}, f), {
              data: papaparse_1.unparse(f.data),
              rawData: f.data,
              matchedParser: parser
            });
          })];
      }
    });
  });
};